import { useAdministrativeContext } from '../../../../../../../pages/administrativePanel/administrativePanelContext'
import { FaTimesCircle, FaCaretDown } from 'react-icons/fa'
import { useState } from 'react'
import { States } from '../States'

import { Container } from './style'


export function Region({ region }) {
    const { removingFromArrayBusiness } = useAdministrativeContext()
    const [openRegion, setOpenRegion] = useState(false)

    function removingRegionFromFilter(states) {
        let idListBusiness = []

        states.map(state => state.business.forEach(business => idListBusiness.push(business.id)))

        removingFromArrayBusiness(idListBusiness)
    }


    return(
        <Container openRegion={openRegion}>
            <div className='regionBullet'/>

            <div className='text'>
                <p onClick={() => setOpenRegion(!openRegion)}>
                    {region.region}
                </p>

                <div className='buttonsActions'>
                    <FaTimesCircle 
                        onClick={() => removingRegionFromFilter(region.states)}
                        className='cleanRegionButton'
                    />
                    <FaCaretDown 
                        className='openButtonRegion'
                        onClick={() => setOpenRegion(!openRegion)}
                    />
                </div>
            </div>

            {
                openRegion &&
                <States 
                    states={region.states}
                />
            }
        </Container>
    )
}
